<template>
  <Tabs :value="type"
        @on-click="onTabClick">
    <TabPane v-for="state in stateList"
             :label="state.label"
             :name="state.name"
             :key="state.name">
      <inventories :ref="state.name"
                   :type="type"
                   :range="range"
                   :branch="branch"
                   :title-status="titleStatus"
                   :search="search"/>
    </TabPane>


    <template slot="extra">
      <Select :value="branch || 'all'"
              style="width: 150px;"
              @on-change="onChangeBranch">
        <Option v-for="item in branchList"
                :value="item.id"
                :key="item.id">
          <template>{{item.name}}</template>
        </Option>
      </Select>

      <Select :value="titleStatus || 'all'"
              style="width: 120px;"
              @on-change="onChangeTitleStatus">
        <Option v-for="item in titleStatusList"
                :value="item.id"
                :key="item.id">
          <template>{{item.name}}</template>
        </Option>
      </Select>

      <DatePicker :value="range"
                  format="MM/dd/yyyy"
                  type="daterange"
                  placement="bottom-end"
                  placeholder="Select date"
                  style="width: 200px; font-size: 12px;"
                  @on-change="onChangeRange"/>

      <Input :value="search"
             type="text"
             placeholder="Search ..."
             style="width: 200px;"
             @on-change="onChangeSearch"/>
    </template>
  </Tabs>
</template>

<script>
import inventories from './_list'
import {Branch} from '../../../models/Branch'

export default {
  props: {
    type: {
      type: String,
      default: 'in_yard',
    },
  },

  components: {
    inventories,
  },

  data() {
    return {
      range: [],
      search: '',
      branch: undefined,
      titleStatus: undefined,
      titleStatusList: [
        {id: 'all', name: 'All Titles'},
        {id: 'yes', name: 'Title: YES'},
        {id: 'no', name: 'Title: NO'},
      ],
      branches: [],
      stateList: [
        {label: 'In Yard', name: 'in_yard,immersed'},
        {label: 'Shipped', name: 'shipped'},
      ],
    }
  },

  mounted() {
    this.reloadBranches();
    this.reload()
  },

  computed: {
    branchList() {
      return [{id: 'all', name: 'All Branches'}, ...this.branches]
    },
  },

  watch: {
    '$route': 'reload',
  },

  methods: {
    reload() {
      this.$nextTick(() => {
        this.$refs[this.type][0].reload()
      })
    },

    reloadBranches() {
      new Branch().all()
          .then(resp => this.branches = resp.data || [])
          .catch(console.log)
    },

    onChangeBranch(item) {
      this.branch = item === 'all' ? undefined : item;
      this.reload()
    },

    onChangeTitleStatus(item) {
      this.titleStatus = item === 'all' ? undefined : item;
      this.reload()
    },

    onTabClick(name) {
      this.prevType = name
      this.$router.push({path: name, query: this.$route.query})

    },

    onChangeRange(range) {
      this.range = range
      this.reload()
    },

    onChangeSearch(event) {
      this.search = event.target.value
      this.reload()
    },
  }
}
</script>